import { useMutation } from "@tanstack/react-query";
import {
  createTransaction,
  updateTransaction,
} from "../service/payment.service";
import type {
  ApiResponse,
  CreateTransactionParams,
  TransactionResponse,
} from "@/types/transaction.type";
import toast from "react-hot-toast";

interface UseTransactionOptions {
  onSuccess?: (data: ApiResponse<TransactionResponse>) => void;
  onError?: (error: Error) => void;
}

export const useCreateTransaction = (options?: UseTransactionOptions) => {
  return useMutation({
    // mutationFn: (params: CreateTransactionParams) => createTransaction(params),
    mutationFn: (params: CreateTransactionParams) => createTransaction(params),
    onSuccess: (data, params) => {
      // ✅ data sudah bentuk ApiResponse<TransactionResponse>
      toast.success(
        params?.is_pending
          ? "Transaksi berhasil di pending"
          : data.message || "Transaksi berhasil disimpan",
      );
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      toast.error(error.message || "Transaksi gagal disimpan");
      options?.onError?.(error);
    },
  });
};
export const useUpdateTransaction = (options?: UseTransactionOptions) => {
  return useMutation({
    // mutationFn: (params: UpdateTransactionParams) => updateTransaction(params),
    mutationFn: (params: CreateTransactionParams) => updateTransaction(params),
    onSuccess: (data, params) => {
      // ✅ data sudah bentuk ApiResponse<TransactionResponse>
      toast.success(
        params?.is_pending
          ? "Transaksi berhasil di pending"
          : data.message || "Transaksi berhasil diupdate",
      );
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      toast.error(error.message || "Transaksi gagal diupdate");
      options?.onError?.(error);
    },
  });
};
